import React from 'react';
import TrendIndicator from '../common/TrendIndicator';

const OverviewCard: React.FC<{
    title: string;
    data: Array<{
        value: number;
        label: string;
        Icon: React.ElementType;
        trend?: string;
        trendType?: 'up' | 'down';
        iconColor: string;
    }>;
}> = ({ title, data }) => (
    <div className="bg-white p-4 rounded-lg shadow ">
        <h3 className="text-base font-semibold text-gray-700 mb-3 pb-2 border-b">{title}</h3>

        <div className="space-y-3">
            {data.map((item, index) => (
                <div key={index} className="flex items-center justify-between border-b pb-5">
                    <div className="flex items-center space-x-2">
                        <div className=""> <item.Icon className={`text-xl ${item.iconColor}`} /></div>
                        <div className=""> <p className="font-bold text-sm text-gray-800">{item.value}</p>
                            <p className="text-sm text-gray-500">{item.label}</p></div>
                    </div>


                    {item.trend && (
                        <TrendIndicator trend={item.trend} trendType={item.trendType || 'up'} />
                    )}
                </div>

            ))}
        </div>
    </div>
);

export default OverviewCard;
